enum PurchaseTypesEnum {
  BONUS_BUY = 'B',
  CADENCE = 'C',
  GUARANTEED = 'G',
  HOUSE_AD = 'H',
  NON_GUARANTEED = 'NG',
  PREFERRED = 'P',
  TAKEOVER = 'T',
}
export default PurchaseTypesEnum;
